import { render, staticRenderFns } from "./DrawingRequestShowHeader.vue?vue&type=template&id=cbbf5bb6&"
import script from "./DrawingRequestShowHeader.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports